import request from '@/utils/request'

//语音合成列表
export function deepseekList(data) {
    return request({
        url: '/general/deepseekConversation/getList',
        method: 'post',
        data: data
    })
}
export function deepseekdel(data) {
    return request({
        url: '/general/deepseekConversation/del',
        method: 'post',
        data: data
    })
}
export function deepseekStream(data) {
    return request({
        url: '/general/api/chat/stream',
        method: 'post',
        data: data
    })
}
export function deepseekChatMessage(data) {
    return request({
        url: '/general/deepseekChatMessage/getList',
        method: 'post',
        data: data
    })
}